"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var moment = require("moment");
var RangePicker = antd_1.DatePicker.RangePicker;
var ToolBarDateRangeFilter = /** @class */ (function (_super) {
    __extends(ToolBarDateRangeFilter, _super);
    function ToolBarDateRangeFilter(props) {
        return _super.call(this, props) || this;
    }
    ToolBarDateRangeFilter.prototype.componentWillMount = function () {
        this.setPropsToState(this.props);
    };
    ToolBarDateRangeFilter.prototype.componentWillReceiveProps = function (nextProps) {
        this.setPropsToState(nextProps);
    };
    ToolBarDateRangeFilter.prototype.setPropsToState = function (Props) {
        this.setState({
            selectedDate: [Props.from.date, Props.to.date]
        });
    };
    ToolBarDateRangeFilter.prototype.getTitle = function () {
        return (React.createElement("div", { style: {
                marginLeft: "5px",
                marginRight: "5px",
                whiteSpace: "nowrap",
                lineHeight: "32px"
            } }, this.props.title));
    };
    ToolBarDateRangeFilter.prototype.onRangeChanged = function (dates, dateStrings) {
        var _this = this;
        this.setState({ selectedDate: dates }, function () {
            //alert(`(changed)from->[${this.state.selectedDate[0].toString()}] to->[${this.state.selectedDate[1].toString()}]`);
            if (_this.props.onClick) {
                _this.props.onClick(_this.state.selectedDate[0], _this.state.selectedDate[1]);
            }
        });
    };
    /* private onOkClicked(selected: RangePickerPresetRange) {
         alert(`(click)from->[${this.state.selectedDate[0].toString()}] to->[${this.state.selectedDate[1].toString()}]`);
         if (this.props.onClick) {
             this.props.onClick(this.state.selectedDate[0], this.state.selectedDate[1]);
         }
     }*/
    ToolBarDateRangeFilter.prototype.getMenu = function () {
        var _this = this;
        return (React.createElement(antd_1.Menu, null,
            React.createElement(antd_1.Menu.Item, { key: "0", onClick: function () { _this.onSelectDate("yesterday"); } }, "\u0412\u0447\u0435\u0440\u0430"),
            React.createElement(antd_1.Menu.Item, { key: "1", onClick: function () { _this.onSelectDate("today"); } }, "\u0421\u0435\u0433\u043E\u0434\u043D\u044F"),
            React.createElement(antd_1.Menu.Item, { key: "2", onClick: function () { _this.onSelectDate("week"); } }, "\u041D\u0435\u0434\u0435\u043B\u044F"),
            React.createElement(antd_1.Menu.Item, { key: "3", onClick: function () { _this.onSelectDate("month"); } }, "\u041C\u0435\u0441\u044F\u0446"),
            React.createElement(antd_1.Menu.Item, { key: "4", onClick: function () { _this.onSelectDate("year"); } }, "\u0413\u043E\u0434"),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: "5", onClick: function () { _this.onSelectDate("month_start"); } }, "\u0421 \u043D\u0430\u0447\u0430\u043B\u0430 \u043C\u0435\u0441\u044F\u0446\u0430")));
    };
    ToolBarDateRangeFilter.prototype.onSelectDate = function (key) {
        if (key == "yesterday") {
            var dtFrom = moment().subtract(1, 'd').set('hour', 0).set('minute', 0);
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
        if (key == "today") {
            var dtFrom = moment().subtract(0, 'd').set('hour', 0).set('minute', 0);
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
        if (key == "week") {
            var dtFrom = moment().subtract(7, 'd').set('hour', 0).set('minute', 0);
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
        if (key == "month") {
            var dtFrom = moment().subtract(1, 'M').set('hour', 0).set('minute', 0);
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
        if (key == "year") {
            var dtFrom = moment().subtract(1, 'y').set('hour', 0).set('minute', 0);
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
        if (key == "month_start") {
            var dtFrom = moment().startOf('month');
            var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
            if (this.props.onClick) {
                this.props.onClick(dtFrom, dtTo);
            }
        }
    };
    ToolBarDateRangeFilter.prototype.render = function () {
        var _css = {
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            alignItems: "center"
        };
        return (React.createElement("div", { style: _css },
            this.getTitle(),
            React.createElement(RangePicker, { showTime: false, format: "YYYY-MM-DD", placeholder: [this.props.from.title, this.props.to.title], onChange: this.onRangeChanged.bind(this), 
                //  onOk={this.onOkClicked.bind(this)}
                value: this.state.selectedDate, disabled: this.props.disabled, style: { minWidth: "250px" }, allowClear: false }),
            React.createElement(antd_1.Dropdown, { overlay: this.getMenu(), trigger: ['click'] },
                React.createElement(antd_1.Button, { icon: "caret-down", ghost: true, type: "primary", style: { marginLeft: "5px" }, onClick: function () { } }))));
    };
    return ToolBarDateRangeFilter;
}(React.Component));
exports.default = ToolBarDateRangeFilter;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarDateRangeFilter.tsx
// module id = 36
// module chunks = 0